import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Bold = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M6.5 21H13c5.655 0 6.5-3.446 6.5-5.5 0-2.008-.872-3.565-2.416-4.502C17.667 10.179 18 9.152 18 8c0-2.897-2.103-5-5-5H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21zM8 6h5c1.271 0 2 .729 2 2 0 1.252-.748 2-2 2H8V6zm0 7h5c1.597 0 3.5.434 3.5 2.5 0 1.265-.271 2.5-3.5 2.5H8v-5z", key: "k0" })));
});
Bold.displayName = 'Bold';
export var BoldDimensions = { height: 24, width: 24 };
